import { Skeleton } from '@mui/material';
import classNames from 'classnames';
import './StatDisplay.scss';
import { IconType } from 'react-icons';
import { IconSkeleton } from 'app/agriculture/components/IconSkeleton';

interface StatDisplaySkeletonProps {
    className?: string;
    hideLabelSkeleton?: boolean;
    showIconSkeleton?: boolean;
    Icon?: IconType;
    label?: string;
    width?: number;
}

export function StatDisplaySkeleton({
    className,
    hideLabelSkeleton = false,
    showIconSkeleton = false,
    Icon = IconSkeleton,
    width,
}: StatDisplaySkeletonProps) {
    return (
        <div className={classNames('StatDisplay', className)}>
            {hideLabelSkeleton ? null : <StatDisplaySkeletonLabel className="StatDisplay__name" />}
            <div className="StatDisplay__content">
                {!showIconSkeleton ? null : <Icon className="StatDisplay__icon" size={16} />}
                <Skeleton
                    className="StatDisplay__value"
                    variant="text"
                    animation="wave"
                    width={width}
                />
            </div>
        </div>
    );
}

function StatDisplaySkeletonLabel({ className, label }: { className?: string; label?: string }) {
    if (label == null) {
        return <Skeleton className={className} variant="text" animation="wave" />;
    }

    return <label className={className}>{label}</label>;
}
